import script from "./SettingsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsSection.vue?vue&type=script&setup=true&lang=js"

import "./SettingsSection.vue?vue&type=style&index=0&id=b989cf5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b989cf5a"]])

export default __exports__